import { z } from 'zod';

import { type BaseItem } from '../common.js';

export enum LlmModelProvider {
  OpenAi = 'OpenAi',
  Anthropic = 'Anthropic',
  CustomLlm = 'CustomLlm',
}

export enum LlmModelType {
  TextBased = 'TextBased',
  RealtimeVoice = 'RealtimeVoice',
}

export const BaseLlmModelSchema = z.object({
  provider: z.nativeEnum(LlmModelProvider),
  modelId: z.string(),
  displayName: z.string(),
  modelType: z.nativeEnum(LlmModelType),
});

type BaseLlmModel = z.infer<typeof BaseLlmModelSchema>;
export type LlmModel = BaseItem & BaseLlmModel;

export const FindAllOptionsSchema = z.object({
  provider: z.nativeEnum(LlmModelProvider).optional(),
  modelType: z.nativeEnum(LlmModelType).optional(),
});
export type FindAllOptions = z.infer<typeof FindAllOptionsSchema>;
